/**
 * How an order's status is drawn.
 *
 * Its own module because two screens read it, and a file that exports both a
 * component and a value opts out of fast refresh — so every edit to the order
 * list would reload the whole application.
 *
 * Two statuses are warnings, and both for the same reason: they are the ones
 * *waiting for somebody at this desk*. `pending_approval` wants a credit
 * decision and `quote_requested` wants a price. An ADV opening the list should
 * be able to see, without reading, whether anything is stuck on them.
 *
 * `quote_sent` is not a warning: the wait is the customer's.
 */

import type { OrderKind, OrderStatus } from "./api";

export type StatusTone = "success" | "warning" | "neutral" | "info";

export const STATUS_TONE: Record<OrderStatus, StatusTone> = {
  pending_approval: "warning",
  confirmed: "info",
  preparing: "info",
  shipped: "info",
  delivered: "success",
  cancelled: "neutral",
  quote_requested: "warning",
  quote_sent: "info",
  quote_accepted: "success",
};

/** Every status a filter may select, in lifecycle order. */
export const STATUSES: OrderStatus[] = [
  "pending_approval",
  "confirmed",
  "preparing",
  "shipped",
  "delivered",
  "cancelled",
  "quote_requested",
  "quote_sent",
  "quote_accepted",
];

/** The two documents, for the list's filter. */
export const KINDS: OrderKind[] = ["order", "quote"];

/** A quotation the desk still has to price. */
export function awaitsPricing(order: { kind: OrderKind; status: OrderStatus }): boolean {
  return order.kind === "quote" && order.status === "quote_requested";
}
